module.exports = __webpack_public_path__ + "media/application/images/2018/2018-fav-plus-23409841e0e1be1ae51a74e1a3d8ba5a.svg";